// @ts-ignore
import { authSubject, usePermissions } from "@bsp/auth";
import React from "react";

import LogoBanrisul from "../assets/logo-banrisul.svg";
import { Text } from "@bem-lib/designsystem";
import { Drawer, Icon, useMediaQuery } from "@bem-lib/designsystem_old";
import { ReactElement, useEffect, useState } from "react";
import { navigateToUrl } from "single-spa";
import { xs } from "../utils/breakpointsTheme";
import { ConfiguracaoIcon } from "./Icons/Configuracao";
import { DocumentoIcon } from "./Icons/Documento";
import { LotesIcon } from "./Icons/Lotes";
import { UsuarioIcon } from "./Icons/Usuario";
import useReactPath from "../hooks/useReactPath";
import {
  ContainerMenu,
  FooterMenu,
  ItemMenu,
  MenuNav,
  MenuNavXS,
} from "./styles";

type Menu = {
  texto: string;
  url: string;
  icone: ReactElement;
};

const Menu: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const matchXS = useMediaQuery(xs);
  const [keycloak, setKeycloak] = useState(null);
  const { hasPermission } = usePermissions();
  const path = useReactPath();

  const menuXS: Menu[] =
    matchXS && hasPermission("Administrador")
      ? [
          {
            texto: "Configurações",
            url: "/configuracoes",
            icone: <ConfiguracaoIcon color="#212121" />,
          },
          {
            texto: "Usuários",
            url: "/usuarios",
            icone: <UsuarioIcon color="#212121" />,
          },
        ]
      : [];

  const listaMenus: Menu[] = [
    {
      texto: "Novo documento",
      url: "/documento/adicionar",
      icone: <DocumentoIcon color="#212121" />,
    },
    {
      texto: "Lotes",
      url: "/documento",
      icone: <LotesIcon color="#212121" />,
    },
    ...menuXS,
  ];

  const handleURLMenu = (url: string) => {
    if (matchXS) {
      setMenuOpen(false);
    }
    navigateToUrl(url);
  };

  const handleLogout = async () => {
    await keycloak?.logout();
  };

  const activeStyle = { color: "var(--primary-mid-light)" };

  useEffect(() => {
    authSubject.subscribe((inscrito) => {
      setKeycloak(inscrito?.keycloak);
    });
  }, []);

  if (!matchXS) {
    return (
      <MenuNav>
        <ul>
          {listaMenus.map((menu) => {
            return (
              <li key={menu.texto}>
                <a
                  style={path === menu.url ? activeStyle : undefined}
                  onClick={() => handleURLMenu(menu.url)}
                >
                  {menu.texto}
                </a>
              </li>
            );
          })}
        </ul>
      </MenuNav>
    );
  }

  if (matchXS) {
    return (
      <>
        <Icon name="Menu" onClick={() => setMenuOpen(true)} />
        <Drawer
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
          className="drawer-menu-hamburguer"
          footer={
            <FooterMenu>
              <Text color="grey-700" onClick={() => handleLogout()}>
                Fazer logout
              </Text>
              <Icon
                name="HomeLogout"
                size={20}
                onClick={() => handleLogout()}
              />
            </FooterMenu>
          }
        >
          <ContainerMenu>
            <img
              src={LogoBanrisul}
              alt="Logo da bemsign"
              className="imagem-logo"
            />
            <MenuNavXS>
              <ul>
                {listaMenus.map((menu) => {
                  return (
                    <li key={menu.texto}>
                      <ItemMenu>
                        {menu.icone}
                        <a
                          style={path === menu.url ? activeStyle : undefined}
                          onClick={() => handleURLMenu(menu.url)}
                        >
                          {menu.texto}
                        </a>
                      </ItemMenu>
                    </li>
                  );
                })}
              </ul>
            </MenuNavXS>
          </ContainerMenu>
        </Drawer>
      </>
    );
  }
};

export default Menu;

